export enum SubSubserviceEnum {
  ServiceTransaction = 'SERVICE_TRANSACTION'
}

export enum ServiceTransactionEnumApi {
  ServiceTransaction = 'serviceTransactions/'
}
